<template>
    <!-- <div>
        <el-cascader :options="brands" v-model="selectedValues" @change="handleChange"
            :props="{ value: 'id', label: 'name', children: 'models' }"></el-cascader>
    </div> -->
    <div class="block">
        <!-- placeholder="友情提示：可以选择全市" -->
        <el-cascader placeholder="友情提示：可以选择全市" class="el-cascader" v-model="cascaderVal" @change="handleChange" :options="options" size="small"
            :props="props" popper-class="disableFirstLevel" collapse-tags clearable></el-cascader>
    </div>
</template>
   
<script>
import { city } from '../../api/userMG'

export default {

    data() {
        return {
            props: { multiple: true },
            options: [],
            selectData: [],
            cascaderVal: [],
            topArr: [],
        };
    },
    created() {
        city(this.ruleForm).then(res => {
            if (res.code == 200) {
                this.options = res.data;
            } else {
                this.$message.error(res.message)
            }
        });
    },

    methods: {
        handleChange(value) {
            var arr = [];
            var newArr = [];
            var arr1 = [];
            //获取所有的省市
            for (var i = 0; i < value.length; i++) {
                if (!arr1.includes(value[i][0] + value[i][1])) {
                    arr1.push(value[i][0] + value[i][1]);
                }
            }
            debugger
            // 当前选中的省市只有一个时
            if (arr1.length == 1) {
                arr = arr1;
            } else {
                // 当前选中的省市有两个时取新的
                for (var i = 0; i < value.length; i++) {
                    let pc = value[i][0] + value[i][1];
                    if (!this.topArr.includes(pc)) {
                        arr = [];
                        arr.push(pc);
                    }
                }
            }
            for (var i = 0; i < value.length; i++) {
                let pc = value[i][0] + value[i][1];
                if ((arr.length > 0 && arr.includes(pc))) {
                    newArr.push(value[i]);
                }
            }
            this.cascaderVal = newArr;
            this.topArr = arr;
            this.selectData = value;
        },
    },
};
</script>

<style>
.el-cascader {
    width: 250px;
}

.disableFirstLevel {
    .hn-cascader-menu:first-of-type {
        .hn-checkbox {
            display: none;
        }
    }
}

.el-scrollbar.el-cascader-menu:first-child li[aria-haspopup] .el-checkbox{
  display:none;
}

</style>


// WEBPACK FOOTER //
// src/views/assembly/Cascader.vue